'use strict';

import 'components/light-box';
import './component.scss';

import lightBox from 'components/light-box';

const CONTAINER_DEFAULT_HEIGHT = 56,
      CONTAINER_MAX_HEIGHT = 300,
      VERTICAL_PADDING = 14;

let expandCollapseButton,
    marketingMessageLinks,
    contentMarketingMessage,
    mmCollapse,
    mmTogler;

function init() {
    let container = document.querySelector('.marketing-message'),
        scrollContent = container ? container.querySelector('.marketing-message-scroll') : null;

    expandCollapseButton = document.querySelector('.marketing-message-expand-collapse-button');
    marketingMessageLinks = document.querySelectorAll('.marketing-message-scroll a');
    contentMarketingMessage = document.querySelector('.marketing-message-scroll');
    mmCollapse = document.querySelector('.marketing-message-collapse');
    mmTogler = document.querySelector('.marketing-message-toggler');

    if (mmTogler) {
        if (scrollContent) {
            // Check if there is imgs in the content and if they are loaded
            let images = scrollContent.querySelectorAll('img');
            if (images.length > 0) {
                checkForUnloadedImages(images);
            }

            setHeight();

            mmTogler.addEventListener('change', () => {
                setHeight();
            });

            window.addEventListener('resize', () => {
                setHeight();
            });
        }

        addExpandCollapseListener(expandCollapse);
        marketingMessageListener();

        mmTogler.addEventListener('light-box:opening', event => {
            let modal = event.detail,
                content = modal.querySelector('.marketing-message-content');

            modal.classList.remove('marketing-message--change');
            if (content && getComputedStyle(content).position === 'fixed') {
                let modalRect = modal.getBoundingClientRect(),
                    wrapperRect = modal.firstElementChild.getBoundingClientRect(),
                    viewportWidth = document.documentElement.offsetWidth;   // viewport width minus scrollbar width
                content.style.top = modalRect.top + 'px';
                content.style.bottom = (window.innerHeight - modalRect.bottom) + 'px';
                content.style.left = wrapperRect.left + 'px';
                content.style.right = (viewportWidth - wrapperRect.right) + 'px';
            }
        });

        mmTogler.addEventListener('light-box:open', event => {
            openAccessibility();
        });

        mmTogler.addEventListener('light-box:close', event => {
            let modal = event.detail,
                content = modal.querySelector('.marketing-message-content');
            if (content && getComputedStyle(content).position === 'fixed') {
                content.style.top = 'auto';
                content.style.bottom = 'auto';
                content.style.left = 'auto';
                content.style.right = 'auto';
            }
            closeAccsessibility();
        });
    }

    lightBox.init0();
}

/*
 * The height of the message box adapts depending on the message length (collapsed and expanded view)
 */

function setHeight() {
    let container = document.querySelector('.marketing-message'),
        scrollContent = container ? container.querySelector('.marketing-message-scroll') : null,
        content = document.querySelector('.marketing-message-content'),
        iconContainer = document.querySelector('.marketing-message-icon-container'),
        scrollContainerHeight = scrollContent ? scrollContent.scrollHeight + VERTICAL_PADDING : null;

    if (mmTogler.checked) {
        if (scrollContainerHeight > CONTAINER_MAX_HEIGHT) {
            content.style.height = CONTAINER_MAX_HEIGHT + 'px';
            scrollContent.style.overflow = 'auto';
            scrollContent.style.height = '100%';
        } else {
            content.style.height = scrollContainerHeight + 'px';
        }
    } else {
        content.style.height = CONTAINER_DEFAULT_HEIGHT + 'px';
        scrollContent.style.overflow = 'hidden';
    }

    if (scrollContainerHeight > CONTAINER_DEFAULT_HEIGHT) {
        if (!mmTogler.checked) {
            content.style.height = CONTAINER_DEFAULT_HEIGHT + 'px';
            scrollContent.style.height = '100%';
        }
        iconContainer.style.height = CONTAINER_DEFAULT_HEIGHT - VERTICAL_PADDING + 'px';
        container.style.height = CONTAINER_DEFAULT_HEIGHT + 'px';
    } else {
        content.style.height = scrollContainerHeight + 'px';
        iconContainer.style.height = scrollContainerHeight - VERTICAL_PADDING + 'px';
        container.style.height = scrollContainerHeight + 'px';
    }

    preventOpening(container, scrollContent);
}

function preventOpening(container, scrollContent) {
    if (CONTAINER_DEFAULT_HEIGHT - VERTICAL_PADDING >= scrollContent.scrollHeight) {
        if (mmTogler.hasAttribute("checked")) {
            container.classList.remove('prevent-opening');
            mmCollapse.classList.add('expanded-by-default');
        } else {
            container.classList.add('prevent-opening');
        }
    } else {
        container.classList.remove('prevent-opening');
        preventAccessMarketingMessage();
    }
}

function checkForUnloadedImages(images) {
    for (let img of images) {
        if (!img.complete && img.naturalHeight === 0) {
            img.addEventListener('load', () => {
                setHeight();
            });
        }
    }
}

// ACCESSIBILITY FEATURES

// Executes when marketing message opens
function openAccessibility() {
    expandCollapseButton.setAttribute('aria-expanded', 'true');
    contentMarketingMessage.setAttribute('tabindex', '0');

    accessMarketingMessage();
    removeExpandCollapseListener(expandCollapse);
    addExpandCollapseListener(expandCollapseOpened);

    setTimeout(() => {
        contentMarketingMessage.focus();
    }, 50);
}

// Executes when marketing message closes
function closeAccsessibility() {
    expandCollapseButton.setAttribute('aria-expanded', 'false');
    contentMarketingMessage.removeAttribute("tabindex");

    removeExpandCollapseListener(expandCollapseOpened);
    addExpandCollapseListener(expandCollapse);
    preventAccessMarketingMessage();
}

// Sets marketing message links visible for screen reader
function accessMarketingMessage() {
    contentMarketingMessage.setAttribute('role', 'dialog');
    contentMarketingMessage.setAttribute('aria-modal',  'true');
    contentMarketingMessage.removeAttribute('aria-hidden');

    for (const link of marketingMessageLinks) {
        link.setAttribute('tabindex', '0');
        link.setAttribute('aria-hidden', 'false');
    }
}

// Sets marketing message links invisible for screen reader
function preventAccessMarketingMessage() {
    contentMarketingMessage.removeAttribute('role');
    contentMarketingMessage.removeAttribute('aria-modal');
    contentMarketingMessage.setAttribute('aria-hidden', 'true');

    for (const link of marketingMessageLinks) {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
    }
}

// Marketing message listener
function marketingMessageListener() {
    contentMarketingMessage.addEventListener('keydown', (e) => {
        e.stopPropagation();

        // Keeps the focus inside the marketing message if the user tries to tab-out
        if(e.target === e.currentTarget){
            if (e.shiftKey && e.keyCode === 9) { // shift + tab
                e.preventDefault();
                expandCollapseButton.focus();
            }
        }
        // Collapses the marketing message and shifts the focus to the expand collapse button
        if (e.keyCode === 27) { // Esc
            expandCollapseButton.click();
            expandCollapseButton.focus();
        }
    })
}


// Expand collapse button listeners
function addExpandCollapseListener(callback) {
    expandCollapseButton.addEventListener('keydown', callback, true)
}

function removeExpandCollapseListener(callback) {
    expandCollapseButton.removeEventListener('keydown', callback, true);
}

// Listens for enter or space key on expand/collapse button
function expandCollapse(e) {
    e.stopPropagation();

    if (e.keyCode === 13 || e.keyCode === 32) { // Enter or Space
        e.preventDefault();
        expandCollapseButton.click();
    }
}

// Locks the focus inside marketing message untill user press esc or expand collapse button
function expandCollapseOpened(e) {
    e.stopPropagation();

   if (!e.shiftKey && e.keyCode === 9) { // Tab
        e.preventDefault();
        contentMarketingMessage.focus();

    } else if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 27) { // Enter, Space or Escape
        e.preventDefault()
        expandCollapseButton.click();
    }
}


window.addEventListener('DOMContentLoaded', init);

export default { init, setHeight };